<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div>
<div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PP1.w.0.1.0"></a><a id="GBS.PP1.w.0.1.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PP2"></a>
<a id="GBS.PP1.w.0.2.0"></a><img alt="Image for page 1" src="data/content-0002.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.0.2.0.1"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA1"></a>
<a id="GBS.PP1.w.0.3.0"></a><img alt="Image for page 4" src="data/content-0003.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.0.3.0.1"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA3"></a>
<a id="GBS.PP1.w.0.4.0"></a><img alt="Image for page 6" src="data/content-0004.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.0.4.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA4"></a>
<a id="GBS.PP1.w.1.0.0"></a><img alt="Image for page 7" src="data/content-0005.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.1.0.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PA5"></a>
<div class="gtxt_body" id="block.8.0.0.box.367.746.772.85.q.70">
<a id="ORIG-GBS.PA5.w.0.0.0"></a><p class="gtxt_body" id="para.8.0.0.box.367.746.772.42.q.70" style="font-size:102%;text-align:center;"><a id="GBS.PP2"></a><a id="GBS.PP2.w.0.0.0"></a><a id="GBS.PP2.w.1.0.0"></a><a id="GBS.PP2.w.1.1.0"></a>This book is dedicate<a id="GBS.PP2.w.1.2.0"></a><a id="GBS.PP2.w.2.0.0"></a><a id="GBS.PP2.w.2.1.0"></a><a id="GBS.PP2.w.3.0.0"></a><a id="GBS.PP3"></a><a id="GBS.PP3.w.0.0.0"></a><a id="GBS.PP4"></a><a id="GBS.PP4.w.0.0.0"></a>d to my daughter,</p><a id="GBS.PA1"></a><a id="GBS.PA1.w.0.0.0"></a><a id="GBS.PA1.w.1.0.0"></a>
<a id="GBS.PA1.w.1.0.0.1"></a><a id="GBS.PA1.w.1.1.0"></a><a id="ORIG-GBS.PA5.w.0.1.0"></a><p class="gtxt_body" id="para.8.0.1.box.476.799.556.32.q.80" style="font-size:102%;text-align:center;text-align:center;"><a id="GBS.PA2"></a><a id="GBS.PA2.w.0.0.0"></a><a id="GBS.PA3"></a><a id="GBS.PA3.w.0.0.0"></a><a id="GBS.PA3.w.1.0.0"></a><a id="GBS.PA3.w.1.1.0"></a><a id="GBS.PA3.w.2.0.0"></a><a id="GBS.PA3.w.2.1.0"></a><a id="GBS.PA3.w.3.0.0"></a><a id="GBS.PA3.w.4.0.0"></a><a id="GBS.PA3.w.4.1.0"></a><a id="GBS.PA4"></a><a id="GBS.PA4.w.0.0.0"></a><a id="GBS.PA4.w.1.0.0"></a><a id="GBS.PA4.w.2.0.0"></a>ANNE KENNEDY WALKER</p><a id="GBS.PA4.w.2.1.0"></a><a id="GBS.PA4.w.3.0.0"></a>
</div><a id="GBS.PA4.w.4.0.0"></a><a id="GBS.PA4.w.4.1.0"></a>
</div><div style="display:none;"><a id="GBS.PA4.w.4.2.0"></a></div><div style="display:none;"><a id="GBS.PA4.w.4.3.0"></a></div><div style="display:none;"><a id="GBS.PA4.w.5.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA4.w.5.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA4.w.6.0.0"></a></div><div class="flow" style=""><a id="GBS.PA4.w.7.0.0"></a>
</div><div style="display:none;"><a id="GBS.PA4.w.8.0.0"></a></div><div style="display:none;"><a id="GBS.PA4.w.9.0.0"></a></div><div style="display:none;"><a id="GBS.PA4.w.10.0.0"></a></div>
<div class="flow" style=""><a id="GBS.PA4.w.11.0.0"></a>
<a class="page full_page_skipped" id="ORIG-GBS.PA7"></a><a id="GBS.PA4.w.12.0.0"></a>
</div><div style="display:none;"><a id="GBS.PA5"></a><a id="GBS.PA5.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PA5.w.0.1.0"></a></div><div style="display:none;"><a id="GBS.PA6"></a><a id="GBS.PA6.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA6.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA7"></a><a id="GBS.PA7.w.0.0.0"></a></div><div class="flow" style=""><a id="GBS.PA7.w.1.0.0"></a><a id="GBS.PA7.w.1.1.0"></a><a id="GBS.PA7.w.1.2.0"></a><a id="GBS.PA7.w.1.3.0"></a><a id="GBS.PA7.w.1.4.0"></a><a id="GBS.PA7.w.1.5.0"></a><a id="GBS.PA7.w.1.6.0"></a><a id="GBS.PA7.w.1.7.0"></a><a id="GBS.PA7.w.1.8.0"></a><a id="GBS.PA7.w.1.9.0"></a><a id="GBS.PA7.w.1.10.0"></a><a id="GBS.PA7.w.1.11.0"></a><a id="GBS.PA7.w.2.0.0"></a><a id="GBS.PA8"></a><a id="GBS.PA8.w.0.0.0"></a><a id="GBS.PA8.w.1.0.0"></a>
<a id="GBS.PA8.w.1.0.0.1"></a><a id="GBS.PA8.w.1.0.0.2"></a><div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PA8"></a>
<a id="GBS.PA8.w.1.0.0.3"></a><img alt="Image for page 11" src="data/content-0006.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PA8.w.1.0.0.4"></a></div><div style="display:none;"><a id="GBS.PA9"></a><a id="GBS.PA9.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA9.w.0.0.0.1"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0007.vue?46234812